import { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useModal } from "hooks/useModal";
import { Spinner3 } from "components/Spinner3";
import { getCertificateDetails, TCertificateDetails } from "services/certificateApi";

import styles from "./certificateModal.module.scss";

interface ICertificateModal {
  link: string;
}

export const CertificateButton: FC<ICertificateModal> = ({ link }) => {
  const [shown, setShown, Modal] = useModal();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState<TCertificateDetails | null>(null);

  useEffect(() => {
    if (!shown || !link) {
      return;
    }

    setLoading(true);
    setDetails(null);
    getCertificateDetails({ link })
      .then((res) => setDetails(res))
      .catch((e) => {
        toast.error(e.response?.data?.message || "Не удалось загрузить сертификат");
      })
      .finally(() => setLoading(false));
  }, [shown, link]);

  if (!link) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={styles.certButton}
        onClick={() => setShown(true)}
      >
        cert
      </button>
      <Modal className={styles.modal}>
        <div className={styles.title}>Сертификат</div>
        {loading && (
          <div className={styles.spinner}>
            <Spinner3 />
          </div>
        )}
        <div className={styles.row}>
          <span className={styles.label}>Статус</span>
          <span>{details?.status || "—"}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>Дата регистрации</span>
          <span>{details?.registrationDate || "—"}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>Срок действия до</span>
          <span>{details?.expiryDate || "—"}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>Заявитель</span>
          <span>{details?.applicant || "—"}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>Ссылка</span>
          <a href={link} target="_blank" rel="noreferrer">
            Открыть в реестре
          </a>
        </div>
      </Modal>
    </>
  );
};
